module.exports = __webpack_public_path__ + "img/icon_qrecode.7cdc06c8.svg";